module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row p-mt-3"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('DataTable', {
    staticClass: "editable-cells-table",
    attrs: {
      "value": _vm.salesItemList,
      "paginator": true,
      "rows": 5,
      "editMode": "cell"
    }
  }, [_c('Column', {
    attrs: {
      "header": "Item",
      "field": "itemName"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Qty",
      "field": "quantity",
      "bodyStyle": "width:50%"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('InputNumber', {
          staticStyle: {
            "width": "3em"
          },
          attrs: {
            "onfocus": "if (this.value === '0')\n                                    this.value = ''",
            "showButtons": "",
            "buttonLayout": "horizontal",
            "decrementButtonClass": "p-button-danger",
            "incrementButtonClass": "p-button-success",
            "incrementButtonIcon": "pi pi-plus",
            "decrementButtonIcon": "pi pi-minus",
            "min": 0,
            "max": 100
          },
          model: {
            value: (slotProps.data[slotProps.column.field]),
            callback: function($$v) {
              _vm.$set(slotProps.data, slotProps.column.field, $$v)
            },
            expression: "slotProps.data[slotProps.column.field]"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Rate",
      "field": "sellingPrice"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [(_vm.enableRateEdit) ? _c('InputNumber', {
          attrs: {
            "onfocus": "if (this.value === '0')\n                                    this.value = ''"
          },
          model: {
            value: (slotProps.data.sellingPrice),
            callback: function($$v) {
              _vm.$set(slotProps.data, "sellingPrice", $$v)
            },
            expression: "slotProps.data.sellingPrice"
          }
        }) : _c('InputNumber', {
          attrs: {
            "disabled": "",
            "onfocus": "if (this.value === '0')\n                                    this.value = ''"
          },
          model: {
            value: (slotProps.data.sellingPrice),
            callback: function($$v) {
              _vm.$set(slotProps.data, "sellingPrice", $$v)
            },
            expression: "slotProps.data.sellingPrice"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Total"
    }
  }, [
    [_c('InputNumber', {
      attrs: {
        "onfocus": "if (this.value === '0')\n                                    this.value = ''",
        "{{slotProps.data.sellingPrice": "",
        "*": "",
        "slotProps.data.sellingPrice}}": ""
      }
    })]
  ], 2), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Action"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          staticClass: "p-button-danger p-button-text",
          attrs: {
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.removeItemFromList(slotProps.index)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.findTotalQuantity) + _vm._s(_vm.findDueAmt) + _vm._s(_vm.calculateTotal))]), _vm._v(" "), _c('Card', {
    staticClass: "p-mt-3 p-mb-3",
    scopedSlots: _vm._u([{
      key: "content",
      fn: function() {
        return [_c('div', [_vm._v("Total Quantity: "), _c('label', {
          staticClass: "p-ml-4"
        }, [_vm._v(_vm._s(_vm.totalQuantity))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_vm._v("Sub Total:"), _c('label', {
          staticClass: "p-ml-4"
        }, [_vm._v(_vm._s('Rs. ' + _vm.subTotal))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_vm._v("Total:"), _c('label', {
          staticClass: "p-ml-4"
        }, [_vm._v(_vm._s('Rs. ' + _vm.totalBillAmount))])]), _vm._v(" "), _c('hr')]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-12"
  }, [_c('label', [_vm._v("Tender Amount:")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "onfocus": "if (this.value === '0.00')\n                                this.value = ''",
      "mode": "decimal",
      "minFractionDigits": 2
    },
    model: {
      value: (_vm.tenderAmount),
      callback: function($$v) {
        _vm.tenderAmount = $$v
      },
      expression: "tenderAmount"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-12"
  }, [(_vm.dueAmount < 0) ? _c('h4', [_vm._v("Return Amount: "), _c('b', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s('Rs. ' + _vm.dueAmount))])]) : _vm._e(), _vm._v(" "), (_vm.dueAmount > 0) ? _c('h4', [_vm._v("Return Amount: "), _c('b', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(_vm._s('Rs. ' + _vm.dueAmount))])]) : _vm._e(), _vm._v(" "), (_vm.dueAmount === 0) ? _c('h4', [_vm._v("Return Amount: "), _c('b', {
    staticStyle: {
      "color": "grey"
    }
  }, [_vm._v(_vm._s('Rs. ' + _vm.dueAmount))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "status1"
    }
  }, [_vm._v("Pay By:")]), _vm._v(" "), _c('RadioButton', {
    attrs: {
      "id": "status1",
      "name": "Cash",
      "value": "CASH"
    },
    model: {
      value: (_vm.paymentMethod),
      callback: function($$v) {
        _vm.paymentMethod = $$v
      },
      expression: "paymentMethod"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "p-mr-3",
    attrs: {
      "for": "status1"
    }
  }, [_vm._v("Cash")]), _vm._v(" "), _c('RadioButton', {
    attrs: {
      "id": "status2",
      "name": "Esewa",
      "value": "ESEWA"
    },
    model: {
      value: (_vm.paymentMethod),
      callback: function($$v) {
        _vm.paymentMethod = $$v
      },
      expression: "paymentMethod"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "status2"
    }
  }, [_vm._v("Esewa")])], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "status1"
    }
  }, [_vm._v("Paid Status:")]), _vm._v(" "), _c('RadioButton', {
    attrs: {
      "id": "status1",
      "name": "paid",
      "value": "PAID"
    },
    model: {
      value: (_vm.paymentStatus),
      callback: function($$v) {
        _vm.paymentStatus = $$v
      },
      expression: "paymentStatus"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "p-mr-3",
    attrs: {
      "for": "status1"
    }
  }, [_vm._v("Paid")]), _vm._v(" "), _c('RadioButton', {
    attrs: {
      "id": "status2",
      "name": "unpaid",
      "value": "UNPAID"
    },
    model: {
      value: (_vm.paymentStatus),
      callback: function($$v) {
        _vm.paymentStatus = $$v
      },
      expression: "paymentStatus"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "status2"
    }
  }, [_vm._v("Unpaid")])], 1), _vm._v(" "), (_vm.paymentStatus === 'UNPAID') ? _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Address:")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "address"
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = $$v
      },
      expression: "address"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.paymentStatus === 'UNPAID') ? _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "delivery"
    }
  }, [_vm._v("Delivery Amount:")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "delivery"
    },
    model: {
      value: (_vm.deliveryCharge),
      callback: function($$v) {
        _vm.deliveryCharge = $$v
      },
      expression: "deliveryCharge"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.paymentStatus === 'UNPAID') ? _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "remarks"
    }
  }, [_vm._v("Remarks:")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "remarks"
    },
    model: {
      value: (_vm.remarks),
      callback: function($$v) {
        _vm.remarks = $$v
      },
      expression: "remarks"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('Button', {
    staticClass: " p-mt-4 p-button-success",
    attrs: {
      "label": "Submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.savePOSEntry.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('Button', {
    staticClass: " p-mt-4 p-button-danger",
    attrs: {
      "label": "Cancel"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('DataView', {
    attrs: {
      "value": _vm.displayItemList,
      "paginator": true,
      "rows": 6,
      "layout": _vm.layout
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "p-grid p-nogutter"
        }, [_c('div', {
          staticClass: "p-field p-col-12 p-md-6"
        }, [_c('RadioButton', {
          attrs: {
            "id": "barcode",
            "name": "Barcode",
            "value": "Barcode"
          },
          model: {
            value: (_vm.searchByBarcode),
            callback: function($$v) {
              _vm.searchByBarcode = $$v
            },
            expression: "searchByBarcode"
          }
        }), _vm._v(" "), _c('label', {
          staticClass: "p-mr-3",
          attrs: {
            "for": "barcode"
          }
        }, [_vm._v("Barcode")]), _vm._v(" "), _c('RadioButton', {
          attrs: {
            "id": "search",
            "name": "Search",
            "value": "Search"
          },
          on: {
            "change": _vm.focusOnPageLoad
          },
          model: {
            value: (_vm.searchByBarcode),
            callback: function($$v) {
              _vm.searchByBarcode = $$v
            },
            expression: "searchByBarcode"
          }
        }), _vm._v(" "), _c('label', {
          attrs: {
            "for": "search"
          }
        }, [_vm._v("Search")])], 1), _vm._v(" "), _c('InputText', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.searchByBarcode === 'Search'),
            expression: "searchByBarcode==='Search'"
          }],
          attrs: {
            "placeholder": "Please enter keyword"
          },
          on: {
            "input": _vm.searchItemWithUserInput
          },
          model: {
            value: (_vm.searchTerm),
            callback: function($$v) {
              _vm.searchTerm = $$v
            },
            expression: "searchTerm"
          }
        }), _vm._v(" "), _c('InputText', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.searchByBarcode === 'Barcode'),
            expression: "searchByBarcode === 'Barcode'"
          }],
          ref: "searchbar",
          attrs: {
            "placeholder": "Barcode"
          },
          on: {
            "keypress": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.searchItem($event)
            }
          },
          model: {
            value: (_vm.searchTerm),
            callback: function($$v) {
              _vm.searchTerm = $$v
            },
            expression: "searchTerm"
          }
        })], 1)]
      },
      proxy: true
    }, {
      key: "grid",
      fn: function(slotProps) {
        return [_c('div', {
          staticClass: "p-col-6 p-md-4"
        }, [_c('div', {
          staticClass: "product-grid-item card"
        }, [_c('div', {
          staticClass: "product-grid-item-top"
        }, [_c('div', [_c('i', {
          staticClass: "pi pi-tag product-category-icon"
        }), _vm._v(" "), _c('span', {
          staticClass: "product-category"
        }, [_vm._v(_vm._s(slotProps.data.groupName))])])]), _vm._v(" "), _c('div', {
          staticClass: "product-grid-item-content"
        }, [_c('a', {
          attrs: {
            "href": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addItemToList(slotProps.data)
            }
          }
        }, [_c('img', {
          staticStyle: {
            "height": "100px",
            "width": "100px"
          },
          attrs: {
            "src": slotProps.data.singleImageUrl,
            "alt": slotProps.data.name
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "product-name"
        }, [_vm._v(_vm._s(slotProps.data.name))])]), _vm._v(" "), _c('div', {
          staticClass: "product-grid-item-bottom"
        }, [_c('span', {
          staticClass: "product-price",
          staticStyle: {
            "float": "right",
            "margin": "0em 0.3em"
          }
        }, [_vm._v("Rs." + _vm._s(slotProps.data.salesRate))]), _vm._v(" "), _c('Button', {
          staticClass: "p-button-secondary",
          attrs: {
            "badge": "8",
            "icon": "pi pi-shopping-cart"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addItemToList(slotProps.data)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "product-price",
          attrs: {
            "icon": "pi pi-shopping-cart"
          }
        }, [_vm._v(_vm._s(slotProps.data.closingStock))])], 1)])])]
      }
    }])
  })], 1)])])]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '35vw'
    }),
    attrs: {
      "visible": _vm.printDialog,
      "header": "Do you want to print this bill?",
      "modal": true,
      "closable": false
    },
    on: {
      "update:visible": function($event) {
        _vm.printDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-rounded",
    attrs: {
      "label": "Yes",
      "icon": "pi pi-check"
    },
    on: {
      "click": _vm.printBill
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "icon": "pi pi-times",
      "label": "No"
    },
    on: {
      "click": _vm.closePrintDialog
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-164e6d02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/pos/nocPosSales.vue
// module id = 2058
// module chunks = 0